import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CopyContentIconButton from "./CopyContentIconButton";

function maskSsn(ssn) {
  if (!ssn) return "";
  // Format: ***-**-1234 (show only last 4 digits)
  const cleaned = ssn.replace(/[^0-9]/g, "");
  if (cleaned.length < 4) return ssn;
  const last4 = cleaned.slice(-4);
  return `***-**-${last4}`;
}

export default function HiddenSsnDisplay({ value }) {
  const [visible, setVisible] = React.useState(false);
  const displayValue = visible ? value : maskSsn(value);

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
      {displayValue}
      <IconButton
        size="small"
        onClick={() => setVisible(!visible)}
        onMouseDown={(e) => e.preventDefault()}
      >
        {visible ? (
          <Visibility fontSize="small" />
        ) : (
          <VisibilityOff fontSize="small" />
        )}
      </IconButton>
      <CopyContentIconButton value={value} size="small" />
    </span>
  );
}
